import {
  TListingFetchReason,
  TMachineListingTab,
  TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN,
  TRESPONSE_GET_MACHINE_AND_LINE_DETAILS,
  TRESPONSE_GET_SIBLING_FACTORIES_DROPDOWN,
  TRESPONSE_MACHINE_LIST,
  TRESPONSE_MACHINE_TRANSFER_DROPDOWN,
  TRESPONSE_UPDATE_MACHINE_FIELD_DROPDOWN,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TMachineListState = {
  machineListingInfo: {
    res: TRESPONSE_MACHINE_LIST;
    fetchReason: TListingFetchReason;
  } | null;
  machineListingFilterDropdown: TRESPONSE_UPDATE_MACHINE_FIELD_DROPDOWN | null;
  bulkAssignLocationDropdown: TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN | null;
  siblingFactoriesDropdown: TRESPONSE_GET_SIBLING_FACTORIES_DROPDOWN | null;
  machineTransferDropdown: TRESPONSE_MACHINE_TRANSFER_DROPDOWN | null;
  machineAndLineDetails: TRESPONSE_GET_MACHINE_AND_LINE_DETAILS | null;
  machineListingPagination: TUserPaginationOption;
  currentListingTab: TMachineListingTab;
};

export const TMachineListInfoActionType = {
  GetMachineList: 'GET_MACHINE_LIST' as const,
  GetMachineListSuccess: 'GET_MACHINE_LIST_SUCCESS' as const,
  GetMachineListFailure: 'GET_MACHINE_LIST_FAILURE' as const,
  SetMachineListPagination: 'SET_MACHINE_LIST_PAGINATION' as const,
  GetMachineListFilterDropDown: 'MACHINE_LIST_FILTER_DROPDOWN' as const,
  GetMachineListFilterDropDownSuccess: 'MACHINE_LIST_FILTER_DROPDOWN_SUCCESS' as const,
  GetMachineListFilterDropDownFailure: 'MACHINE_LIST_FILTER_DROPDOWN_FAILURE' as const,
  UpdateMachine: 'UPDATE_MACHINE' as const,
  UpdateMachineFailure: 'UPDATE_MACHINE_SUCCESS' as const,
  UpdateMachineSuccess: 'UPDATE_MACHINE_FAILURE' as const,
  DeleteMachines: 'DELETE_MACHINE' as const,
  DeleteMachinesSuccess: 'DELETE_MACHINE_SUCCESS' as const,
  DeleteMachinesFailure: 'DELETE_MACHINE_FAILURE' as const,
  BulkUpdateStatus: 'UPDATE_BULK_STATUS' as const,
  BulkUpdateStatusSuccess: 'UPDATE_BULK_STATUS_SUCCESS' as const,
  BulkUpdateStatusFailure: 'UPDATE_BULK_STATUS_FAILURE' as const,
  BulkUpdatePrintedStatus: 'UPDATE_BULK_PRINTED_STATUS' as const,
  BulkUpdatePrintedStatusSuccess: 'UPDATE_BULK_PRINTED_STATUS_SUCCESS' as const,
  BulkUpdatePrintedStatusFailure: 'UPDATE_BULK_PRINTED_STATUS_FAILURE' as const,
  GetBulkAssignLocationDropdown: 'GET_BULK_ASSIGN_LOCATION_DROPDOWN' as const,
  GetBulkAssignLocationDropdownSuccess: 'GET_BULK_ASSIGN_LOCATION_DROPDOWN_SUCCESS' as const,
  GetBulkAssignLocationDropdownFailure: 'GET_BULK_ASSIGN_LOCATION_DROPDOWN_FAILURE' as const,
  AssignBulkLocation: 'BULK_ASSIGN_LOCATION' as const,
  AssignBulkLocationSuccess: 'BULK_ASSIGN_LOCATION_SUCCESS' as const,
  AssignBulkLocationFailure: 'BULK_ASSIGN_LOCATION_FAILURE' as const,
  GetMachineTransferDropdown: 'GET_MACHINE_TRANSFER_DROPDOWN' as const,
  GetMachineTransferDropdownSuccess: 'GET_MACHINE_TRANSFER_DROPDOWN_SUCCESS' as const,
  GetMachineTransferDropdownFailure: 'GET_MACHINE_TRANSFER_DROPDOWN_FAILURE' as const,
  MachineTransfer: 'MACHINE_TRANSFER' as const,
  MachineTransferSuccess: 'MACHINE_TRANSFER_SUCCESS' as const,
  MachineTransferFailure: 'MACHINE_TRANSFER_FAILURE' as const,
  GetMachineAndLineDetails: 'GET_MACHINE_AND_LINE_DETAILS' as const,
  GetMachineAndLineDetailsSuccess: 'GET_MACHINE_AND_LINE_DETAILS_SUCCESS' as const,
  GetMachineAndLineDetailsFailure: 'GET_MACHINE_AND_LINE_DETAILS_FAILURE' as const,
  ResetMachineAndLineDetails: 'RESET_MACHINE_AND_LINE_DETAILS' as const,
  GetSiblingFactoriesDropdown: 'GET_SIBLING_FACTORIES_DROPDOWN' as const,
  GetSiblingFactoriesDropdownSuccess: 'GET_SIBLING_FACTORIES_DROPDOWN_SUCCESS' as const,
  GetSiblingFactoriesDropdownFailure: 'GET_SIBLING_FACTORIES_DROPDOWN_FAILURE' as const,
  BulkUpdatePreventiveSchedule: 'BULK_UPDATE_PREVENTIVE_SCHEDULE' as const,
  BulkUpdatePreventiveScheduleSuccess: 'BULK_UPDATE_PREVENTIVE_SCHEDULE_SUCCESS' as const,
  BulkUpdatePreventiveScheduleFailure: 'BULK_UPDATE_PREVENTIVE_SCHEDULE_FAILURE' as const,
  SetMachineListingTab: 'SET_MACHINE_LISTING_TAB' as const,
};
